export const REVIEW_INFO = "review_info";
